import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-employer-contact",
    prompt: (guidanceItem) => `Please set up your employer contacts for plan administration, reporting, and/or invoicing notices. `, 
    briefDescription: 'Employer Contacts',
    openAction: {
        text: "Where to edit employer contacts?",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: "Employer Contacts",
    },
    completeAction: {
    }

});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-employer-contact.js